export default __webpack_public_path__ + "static/hadawa_video_sp-d27864351e69b8b31dffc948635ec50d.webm";